export class Seccion {
    fechaInicio:any;
    constructor() {
        this.fechaInicio=new Date;
    }
}
